import { s2t, t2s } from 'chinese-s2t'

// 简体转繁体
export function toTraditional (text) {
  return typeof text === 'string' ? s2t(text) : text
}

// 繁体转简体（可选）
export function toSimplified (text) {
  return typeof text === 'string' ? t2s(text) : text
}



// WEBPACK FOOTER //
// ./src/plugins/langConvert.js